export default __webpack_public_path__ + "static/media/96t.345458b2.jpg";